export const features = {
	cart: false,
	marker: false,
	navigation: {
		firstFoldableOpen: true,
		firstFoldableDetailOpen: false,
	},
};
